import { COURSE_TYPE, ICourseCartInput } from "@types";
import { FC, Fragment } from "react";
import Card from "@shared/components/card";
import { useCartContext } from "@context/cart";
import { CARD_TAG, CARD_VARIANT } from "@shared/components/card/types";
import { festivalPropsCard } from "@shared/components/card/constants";

interface Props {
  data: ICourseCartInput[];
}
const FestivalCardsList: FC<Props> = ({ data }) => {
  const { cart } = useCartContext();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 sm:gap-6 sm:gap-y-6 mb-8 gap-y-4">
      {data.map((product) => {
        const cardProps = {
          ...product,
          title: product.title_short || product.title,
          slug: product.slug || "",
          isBuy: product.is_buy,
          isFavorite: product.is_favorite,
          watchPercent: product.watchTime_Percent || 0,
          type: product.type as COURSE_TYPE,
          sku: product.sku || "",
          hugElement: false,
          instructor: product.instructors,
          festival: product.festival_new,
          inCart:
            product.in_cart || cart.some((item) => item.id === product.id),
          hasCertificate: product.hasCertificate || false,
          tag: product.hasCertificate ? CARD_TAG.CERTIFICATE : undefined,
          ...festivalPropsCard,
        };
        return (
          <Fragment key={product.id}>
            <div className="sm:hidden">
              <Card
                {...{
                  ...cardProps,
                  variant: CARD_VARIANT.LIST,
                  showDetail: false,
                }}
              />
            </div>
            <div className="hidden sm:block">
              <Card
                {...{
                  ...cardProps,
                  variant: CARD_VARIANT.GRID,
                  showDetail: true,
                }}
              />
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};

export default FestivalCardsList;
